import '@backstage/cli/asset-types';
import '@backstage/ui/css/styles.css';
import './tailwind.built.css';
import ReactDOM from 'react-dom/client';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
